/**
 * Created by Ning Jiang on 2021-06-23.
 */

import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap, TimelineLite} from "gsap";
import {Karen} from "../../Karen";
import {KarenLayers, Layers} from "../../view/KarenLayers";

export class IndividualEffect extends TimelineSprite {

    public winLevel:number;

    constructor(level:number) {
        super(IndividualEffect.getLevelTextures(level), 30);
        this.winLevel = level;
    }

    private static getLevelTextures(level:number):PIXI.Texture[] {
        switch(level) {
            case 0:
                return Karen.assetLoader.getTextures(`initialwin/fire_weak/fireWeak003_`);
            default:
                return Karen.assetLoader.getTextures(`initialwin/fire_weak/fireWeak003_`);

        }
    }
}

export class IndividualWinView {

    private _layer:StageLayer;
    private _effectPool:IndividualEffect[][] = [[]];

    constructor() {
        this._layer = KarenLayers.getLayer(Layers.WIN_PRESENTATIONS)!;
    }

    public playAnimation(position:PIXI.Point, effectLevel:number):TimelineLite {
        const effect = this.getEffect(effectLevel);
        effect.hide();
        effect.position.set(position.x, position.y);
        this._layer.addChild(effect);

        const tl = gsap.timeline();
        tl.add(effect.getAnimationAutoShowHide(true, true));
        tl.add(() => this.recycleEffect(effect));
        return tl;
    }

    private getEffect(effectLevel:number):IndividualEffect {
        if(this._effectPool[effectLevel].length > 0) {
            return this._effectPool[effectLevel].pop()!;
        }

        const effect = new IndividualEffect(effectLevel);
        effect.anchor.set(0.5);
        return effect;
    }

    private recycleEffect(effect:IndividualEffect):void {
        this._layer.removeChild(effect);
        this._effectPool[effect.winLevel].push(effect);
    }
}